import { Provider } from '@angular/core';
import { SplitsRepository } from './core/repositories/splits.repository';
import { HttpSplitsRepository } from './core/repositories/http-splits.repository';

/**
 * Providers del módulo de Split Sheets EPG (Medellín Music Lab)
 * conectados al repositorio PostgreSQL de Medellín Joven.
 */
export function provideSplitsMml(): Provider[] {
  return [
    { provide: SplitsRepository, useExisting: HttpSplitsRepository }
  ];
}
